module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }